import ThisIsSampling from './thisissampling'

export default ThisIsSampling
